(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      theme.ProductBlockManager.loadImages(productRecommendationsSection);
      theme.initAnimateOnScroll();
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tpac-bhpc-landing"] && !Shopify.designMode) return;
  try {
    
(() => {
  const ready = new WeakSet();
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  function prepare(root) {
    root.querySelectorAll('.bhpc-world .bhpc-media').forEach(media => {
      if (ready.has(media)) return;
      const videos = [...media.querySelectorAll('video')];
      const button = media.querySelector('.bhpc-motion');
      if (!videos.length || !button) return;
      ready.add(media);
      let userPaused = reduced.matches;
      let inView = false;
      const active = () => videos.find(video => video.getClientRects().length && video.offsetWidth > 0);
      const sync = () => { const video = active(); const paused = !video || video.paused; button.dataset.paused = String(paused); button.setAttribute('aria-label', (paused ? 'Play ' : 'Pause ') + media.getAttribute('aria-label') + ' video'); };
      const update = () => { const visible = active(); videos.forEach(video => { if (video !== visible || !inView || userPaused || document.hidden) video.pause(); else video.play().catch(sync); }); sync(); };
      videos.forEach(video => { video.muted = true; video.addEventListener('play', sync); video.addEventListener('pause', sync); });
      const observer = new IntersectionObserver(entries => { inView = entries[0].isIntersecting; update(); }, {threshold:.2});
      observer.observe(media);
      button.addEventListener('click', () => { const video = active(); if (!video) return; userPaused = !video.paused; if (userPaused) video.pause(); else video.play().catch(sync); sync(); });
      matchMedia('(max-width:749px)').addEventListener('change', update);
      reduced.addEventListener('change', () => { userPaused = reduced.matches; update(); });
      document.addEventListener('visibilitychange', update);
      sync();
    });
  }
  prepare(document);
  document.addEventListener('shopify:section:load', event => prepare(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tpac-series"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const observedVideos = new WeakSet();
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        if (!entry.isIntersecting) {
          video.pause();
          return;
        }
        if (!reducedMotion.matches && video.dataset.userPaused !== 'true') {
          video.play().catch(() => {});
        }
      });
    }, { threshold: 0.25 });

    const setButtonState = (button, isPaused) => {
      const brand = button.closest('.tpac-brand-section')?.querySelector('.tpac-brand-banner__copy h2')?.textContent?.trim() || (button.closest('.tpac-bhpc-story-media') ? 'Beverly Hills Polo Club story' : '');
      button.dataset.state = isPaused ? 'paused' : 'playing';
      button.setAttribute('aria-label', `${isPaused ? 'Play' : 'Pause'} ${brand} video`.trim());
      const label = button.querySelector('.tpac-visually-hidden');
      if (label) label.textContent = isPaused ? 'Play video' : 'Pause video';
    };

    const prepareVideos = (root = document) => {
      root.querySelectorAll('.tpac-brand-video, .tpac-bhpc-story-video').forEach((video) => {
        const button = video.parentElement.querySelector('.tpac-brand-video-toggle');
        if (reducedMotion.matches) {
          video.pause();
          video.dataset.userPaused = 'true';
          if (button) setButtonState(button, true);
        }
        if (!observedVideos.has(video)) {
          observer.observe(video);
          observedVideos.add(video);
        }
      });
    };

    document.addEventListener('click', (event) => {
      const button = event.target.closest('.tpac-brand-video-toggle');
      if (!button) return;
      const video = button.parentElement.querySelector('.tpac-brand-video, .tpac-bhpc-story-video');
      if (!video) return;
      if (video.paused) {
        video.dataset.userPaused = 'false';
        video.play().then(() => setButtonState(button, false)).catch(() => {});
      } else {
        video.dataset.userPaused = 'true';
        video.pause();
        setButtonState(button, true);
      }
    });

    document.addEventListener('shopify:section:load', (event) => prepareVideos(event.target));
    prepareVideos();
  })();

  } catch(e) { console.error(e); }
})();
})();
